import { Flex, Typography } from "antd"
import React, { useMemo } from "react"

import {
  TEMPLATE_BLOCK_CATEGORY,
  TEMPLATE_BLOCK_CATEGORY_LABEL,
  type TemplateBlockCategory
} from "../../constants/template-block-category.tsx"
import type { DocumentAvailableBlock } from "../../types/types.ts"
import { DocumentTemplateFormGroupsItem } from "./DocumentTemplateFormGroupsItem.tsx"

const CATEGORY_ORDER: TemplateBlockCategory[] = [
  TEMPLATE_BLOCK_CATEGORY.DATA_BOUND,
  TEMPLATE_BLOCK_CATEGORY.CONTENT,
  TEMPLATE_BLOCK_CATEGORY.SIGNATURE,
  TEMPLATE_BLOCK_CATEGORY.APPENDIX,
  TEMPLATE_BLOCK_CATEGORY.LAYOUT
]

interface ProposalTemplatesBuilderGroupsProps {
  loading: boolean
  availableBlocks: DocumentAvailableBlock[]
  onAdd: (block: DocumentAvailableBlock) => void
}

export function DocumentTemplateFormGroups({
  loading,
  availableBlocks,
  onAdd
}: ProposalTemplatesBuilderGroupsProps) {
  const groupedBlocks = useMemo(() => {
    return availableBlocks.reduce<
      Record<TemplateBlockCategory, DocumentAvailableBlock[]>
    >(
      (groups, block) => {
        const category = block.category
        if (!groups[category]) {
          groups[category] = []
        }
        groups[category].push(block)
        return groups
      },
      {} as Record<TemplateBlockCategory, DocumentAvailableBlock[]>
    )
  }, [availableBlocks])

  // const blockTypeCounts = useMemo(() => {
  //   const counts: Record<string, number> = {}
  //   canvasBlocks.forEach((b) => {
  //     counts[b.block_type] = (counts[b.block_type] || 0) + 1
  //   })
  //   return counts
  // }, [canvasBlocks])
  //
  // const isBlockLimitReached = useCallback(
  //   (block: TemplateAvailableBlock): boolean => {
  //     if (block.max_per_template === null) return false
  //     const currentCount = blockTypeCounts[block.block_type] || 0
  //     return currentCount >= block.max_per_template
  //   },
  //   [blockTypeCounts]
  // )

  return (
    <div
      className={"w-56 space-y-4 overflow-y-auto px-1 -mx-1 tailwind-scroll"}
    >
      {CATEGORY_ORDER.map((category) => {
        const blocks = groupedBlocks[category]
        if (!blocks?.length) return null

        return (
          <Flex vertical gap={"small"} key={category}>
            <Typography.Text strong type="secondary">
              {TEMPLATE_BLOCK_CATEGORY_LABEL?.[category] || "No label find"}
            </Typography.Text>

            <Flex className={""} vertical gap={4}>
              {blocks.map((block) => (
                <DocumentTemplateFormGroupsItem
                  key={block.block_type}
                  block={block}
                  onAdd={onAdd}
                  disabled={loading}
                  // disabled={isBlockLimitReached(block)}
                />
              ))}
            </Flex>
          </Flex>
        )
      })}
    </div>
  )
}
